import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Group } from '@mantine/core'
import { AppText } from '../../../app/common/ui'
import { AppButton, AppCard } from '@gunslop/ui'
import LoadingComponent from '../../../app/layout/LoadingComponents'
import { useStore } from '../../../app/stores/ardstore'

export default observer(function ArduinoDetails () {
  const { arduinoStore } = useStore()
  const { selectedArduino: arduino, loadArduino, loadingInitial } = arduinoStore
  const { id } = useParams<{ id: string }>()

  useEffect(() => {
    if (id) loadArduino(id)
  }, [id, loadArduino])

  if (loadingInitial || !arduino) return <LoadingComponent content="Loading..." />

  return (
    <AppCard>
      <AppText weight={700} size="lg" mb="xs">Arduino number: {arduino.id}</AppText>
      <AppText color="dimmed" mb="md">{arduino.value}</AppText>
      <Group grow>
        <AppButton component={Link} to={`/editArduino/${arduino.id}`} variant="light">
          Edit
        </AppButton>
        <AppButton component={Link} to="/arduinos" variant="default">
          Cancel
        </AppButton>
      </Group>
    </AppCard>
  )
})
